import { useForm, ValidationError } from '@formspree/react';

import './ContactUsForm.css';

export default function ContactUsForm({ message }) {
  const [state, handleSubmit] = useForm("mvoylngg");
  if (state.succeeded) {
    return <p>Thank you for reaching out! We will get back to you shortly.</p>;
  }

  return (
    <div className="form-wrapper">
      <form onSubmit={handleSubmit}>
        {/* Name */}
        <label htmlFor="name">
          Name <span className="required">*</span>
        </label>
        <input
          id="name"
          type="text"
          name="name"
          required
        />
        <ValidationError
          prefix="Name"
          field="name"
          errors={state.errors}
        />
        {/* Email */}
        <label htmlFor="email">
          Email Address <span className="required">*</span>
        </label>
        <input
          id="email"
          type="email"
          name="email"
          required
        />
        <ValidationError
          prefix="Email"
          field="email"
          errors={state.errors}
        />
        {/* phone */}
        <label htmlFor="phone">
          Phone Number <span className="required">*</span>
        </label>
        <input
          id="phone"
          type="phone"
          name="phone"
          required
        />
        <ValidationError
          prefix="Phone"
          field="phone"
          errors={state.errors}
        />
        {/* message */}
        <label htmlFor="message">
          {message ? message : "Message"} <span className="required">*</span>
        </label>
        <textarea
          id="message"
          name="message"
          required
        />
        <ValidationError
          prefix="Message"
          field="message"
          errors={state.errors}
        />
        <button className='btn btn-dark' type="submit" disabled={state.submitting}>
          Submit
        </button>
      </form>
    </div>
  )
}